import { Component, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { IUser } from 'src/app/shared/interfaces/user/user.interface';

@Component({
  selector: 'app-create-user-modal',
  templateUrl: './create-user-modal.component.html',
  styleUrls: ['./create-user-modal.component.scss'],
})
export class CreateUserModalComponent {
  @Input() user: IUser;

  constructor(private activeModal: NgbActiveModal) {}

  close(isUserUpdated = false) {
    this.activeModal.close(isUserUpdated);
  }
}
